<template>
    <div id="app">
        <div class="page" v-show="show[0].isShow">
            <div class="question">
            <p>1.请问您的性别是：</p>
            <input type="radio" v-model="picked" value="male" id="male">
            <label for="male">男</label>
            <input type="radio" v-model="picked" value="female" id="female">
            <label for="female">女</label>
            <input type="radio" v-model="picked" value="secret" id="secret">
            <label for="secret">保密</label>
            </div>
            <buttons :classObject="classObject" :isDisabled="isp1Disabled"
            @on-click="handlecustomClick(1)"
            >下一步</buttons>
            <buttons :classObject="classObject" 
            @on-click="handleReset(0)"
            >重置</buttons>
        </div>
        <div class="page" v-show="show[1].isShow">
            <div class="question">
                <p>2.请选择您的兴趣爱好：</p>
                <input type="checkbox" v-model="checked" value="read" id="read">
                <label for="read">看书</label>
                <br/>
                <input type="checkbox" v-model="checked" value="swim" id="swim">
                <label for="swim">游泳</label>
                <br/>
                <input type="checkbox" v-model="checked" value="run" id="run">
                <label for="run">跑步</label>
                <br/>
                <input type="checkbox" v-model="checked" value="movie" id="movie">
                <label for="movie">看电影</label>
                <br/>
                <input type="checkbox" v-model="checked" value="music" id="music">
                <label for="music">听音乐</label>
                <br/>
            </div>
            <buttons :classObject="classObject" :isDisabled="isp2Disabled"
            @on-click="handlecustomClick(2)"
            >下一步</buttons>
            <buttons :classObject="classObject" :isDisabled="isp2Disabled"
            @on-click="handlecustomClick(0)"
            >上一步</buttons>
            <buttons
            :classObject="classObject"
            @on-click="handleReset(1)"
            >重置</buttons>
        </div>
        <div class="page" v-show="show[2].isShow">
            <div class="question">
                <p>3.请介绍一下自己：</p>
                <textarea v-model="message" placeholder="不少于100字"></textarea>
            </div>
            <buttons :classObject="classObject" :isDisabled="isp3Disabled">提交</buttons>
            <buttons :classObject="classObject" :isDisabled="isp3Disabled"
            @on-click="handlecustomClick(1)"
            >上一步</buttons>
            <buttons
            :classObject="classObject"
            @on-click="handleReset(2)"
            >重置</buttons>
        </div>
    </div>
</template>
<script>
import buttons from './components/buttons';
export default {
    components:{
        buttons
    },
    data(){
        return{
            show:[
                {isShow:true},
                {isShow:false},
                {isShow:false}
            ],
            message:'',
            picked:'',
            checked:[],            
            isp1Disabled:true,
            isp2Disabled:true,
            isp3Disabled:true,
            classObject:{
                colorbackground:true
            }
        }
    },
    methods:{
        handlecustomClick(count){
            for(var i=0;i<this.show.length;i++) this.show[i].isShow=false;
            this.show[count].isShow=true;
        },
        handleReset(count){
            switch(count){
                case 0:
                    this.picked='';
                    this.isp1Disabled=true;
                    break;
                case 1:
                    this.checked=[];
                    if(this.checked.length===2){
                        this.isp2Disabled=true;
                    }
                    break;
                case 2:
                    this.message='';
                    this.isp3Disabled=true;
                    break;
            }
        }
    },
    watch:{
        picked(){
            if(this.picked){
                this.isp1Disabled = false;
            }else{
                this.isp1Disabled=true;
            }
        },
        checked(){
            if(this.checked.length>=2){
                this.isp2Disabled=false;
            }else{
                this.isp2Disabled=true;
            }
        },
        message(){
            var len=0;
            for(var i=0;i<this.message.length;i++) len += /[^\x00-\xff]/g.test(this.message.charAt(i)) ? 1 : 0.5;
            if(len >= 100){
                this.isp3Disabled=false;
            }else{
                this.isp3Disabled=true;
            }
        }
    }
}
</script>
<style scoped>
 .page{
     width: 300px;
     height: 500px;
     background: #fff;
     border: 1px solid #d0d0d0;
     border-radius: 5px;
     margin: 10px;
     padding-top: 5px;
 }
 .question{
     height: 450px;
 }
.colorbackground{
    
    
}
</style>